import { post } from "../utils/backend";
import { InvoiceRequest, InvoiceRecord, ProcessInvoiceRequest } from "../models/InvoiceManagement";
import { mock } from "./mock/Mock";
import { getMockData } from "./mock/Mock";
import "./mock/InvoiceMock";

const getUnprocessedRequests = async (): Promise<InvoiceRequest[]> => {
    if (mock) {
        return getMockData("unprocessed_requests");
    }
    const resultOrErrorCode = await post<null, InvoiceRequest[]>("/managerment/invoice/getUnprocessedRequests", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const getProcessedInvoices = async (): Promise<InvoiceRecord[]> => {
    if (mock) {
        return getMockData("processed_invoices");
    }
    const resultOrErrorCode = await post<null, InvoiceRecord[]>("/managerment/invoice/getProcessedInvoices", null);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const processInvoice = async (params: ProcessInvoiceRequest): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<ProcessInvoiceRequest, boolean>("/managerment/invoice/process", params);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return resultOrErrorCode;
};

export const InvoiceApi = {
    getUnprocessedRequests,
    getProcessedInvoices,
    processInvoice
};